/* import __COLOCATED_TEMPLATE__ from './name-fields.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';

/**
## Name Fields

Provides ordering for fields that are used for a first and last name, and should be reordered for
Japanese merchants who would display it as last name then first name.

```handlebars
{{#name-fields as |section|}}
  <div class="{{if section.isDisplayedFirst 'first-col' 'last-col'}}">
    {{#if section.isFirstName}}
      {{validated-input value=firstName fieldName="firstName"}}
    {{else}}
      {{validated-input value=lastName fieldName="lastName"}}
    {{/if}}
  </div>
{{/name-fields}}
```
*/
// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  userInfo: service(),
  tagName: ''
});